<template>
    <div class="file-upload">
        <div
            class="drop-area"
            @dragover.prevent="handleDragOver"
            @dragleave="handleDragLeave"
            @drop.prevent="handleDrop"
            :class="{ 'drag-over': isDragging }"
            @click="triggerFileInput"
        >
            <p>Click and Drop</p>
        </div>
        <div v-if="files.data.length === 1">
            <p>{{ files.data[0].name }} <button @click="delList(0)">삭제</button></p>
        </div>
        <div v-if="files.data.length > 1">
            <p>
                {{ files.data[0].name }} 외 {{ files.data.length - 1 }}개
                <button class="moreBtn" :class="state.isMoreList ? 'active' : ''" @click="moreList"></button>
            </p>
        </div>
        <div class="fullList" v-if="state.isMoreList && files.data.length > 1">
            <div class="closeMoreList">
                <button @click="closeList">
                    <img class="colseBtn" src="@/assets/close_btn.png" alt="" />
                </button>
            </div>
            <div class="moreList">
                <ul>
                    <li v-for="(item, idx) in files.data">
                        {{ item.name }}
                        <button class="removeFile" @click="delList(idx)">
                            <img class="colseBtn" src="@/assets/close_btn.png" alt="" />
                        </button>
                    </li>
                </ul>
            </div>
        </div>
        <input
            type="file"
            id="fileInput"
            :multiple="!state.isSingleFile"
            @change="handleFileChange"
            hidden
            :accept="state.acceptFileTag"
        />
    </div>
</template>

<script lang="ts">
    import { onMounted, reactive, ref, watch } from "vue";

    export default {
        props: {
            fileType: {
                type: String,
                default: "",
            },
            isSingleFile: {
                type: Boolean,
                default: false,
            },
        },
        emits: [],
        setup(props: any) {
            const isDragging = ref(false);
            const state = reactive({
                isSingleFile: props.isSingleFile as boolean,
                fileType: "" as string,
                isMoreList: false as boolean,
                acceptFileTag: "" as string,
            });
            const files = reactive({
                data: [] as Array<File>,
                fileType: [] as Array<string>,
            });

            onMounted(() => {
                state.acceptFileTag = props.fileType
                    .replace("image", "image/*")
                    .replace("video", "video/*")
                    .replace("audio", "audio/*");
            });

            watch(
                () => files.fileType,
                () => {
                    state.acceptFileTag = files.fileType
                        .join(", ")
                        .replace("image", "image/*")
                        .replace("video", "video/*")
                        .replace("audio", "audio/*");
                },
            );
            const handleDragOver = () => {
                isDragging.value = true;
            };

            const handleDragLeave = () => {
                isDragging.value = false;
            };

            // 드롭된 파일 처리
            const handleDrop = (event: DragEvent) => {
                isDragging.value = false;
                if (event.dataTransfer) {
                    checkExistFiles(event.dataTransfer.files);
                }
            };

            const handleFileChange = (event: Event) => {
                const target = event.target as HTMLInputElement;
                if (target.files) {
                    checkExistFiles(target.files);
                }
            };
            const fileFilter = (fileList: Array<File>) => {
                let acceptList = [] as Array<File>;
                for (let i = 0; i < fileList.length; i++) {
                    const tempFile: File = fileList[i];
                    const fileTypePrefix = tempFile.type.split("/")[0];
                    if (files.fileType.length === 0 || files.fileType.includes(fileTypePrefix)) {
                        acceptList.push(tempFile);
                    } else {
                        console.warn("잘못된 파일이 있습니다(확장자 명을 확인해 주세요):", tempFile.name);
                    }
                }
                return acceptList;
            };
            const checkExistFiles = (fileList: FileList) => {
                const list = [] as Array<File>;
                state.isMoreList = false;
                for (let i = 0; i < fileList.length; i++) {
                    const duplicate = files.data.find(
                        (item) => item.name === fileList[i]?.name && item.lastModified === fileList[i]?.lastModified,
                    );
                    if (duplicate === undefined || duplicate === null) {
                        list.push(fileList[i]);
                    }
                }
                files.data = fileFilter(list);
            };

            const triggerFileInput = () => {
                const fileInput = document.getElementById("fileInput") as HTMLInputElement;
                fileInput.click();
            };

            const moreList = () => {
                state.isMoreList = true;
            };

            const closeList = () => {
                state.isMoreList = false;
            };

            const delList = (idx: number) => {
                files.data.splice(idx, 1);
            };
            return {
                state,
                isDragging,
                files,
                handleDragOver,
                handleDragLeave,
                handleDrop,
                handleFileChange,
                triggerFileInput,
                moreList,
                closeList,
                props,
                delList,
            };
        },
    };
</script>

<style scoped>
    .file-upload {
        min-width: 400px;
        max-width: 600px;
        width: 100%;
        margin: 0 auto;
        text-align: center;
    }

    .drop-area {
        min-height: 150px;
        max-height: 800px;
        height: 100%;
        border: 2px dashed #ccc;
        padding: 20px;
        margin-bottom: 10px;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }

    .drop-area.drag-over {
        background-color: #f0f0f0;
    }

    .moreBtn.active {
        transform: rotate(180deg);
        transition: all 0.5s;
    }

    .moreBtn {
        display: inline-block;
        width: 14px;
        height: 14px;
        background-image: url(/src/assets/down_arrow.png);
        background-size: contain;
        background-position: center;
        vertical-align: middle;
        transition: all 0.5s;
    }

    .fullList {
        background-color: rgb(235, 235, 235);
        border-radius: 10px;
        margin: 0 auto;
        max-width: 400px;
        height: 350px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding-left: 2%;
        padding-bottom: 20px;
    }

    .colseBtn {
        width: 20px;
    }

    .closeMoreList {
        width: 95%;
        padding-bottom: 5px;
        padding-top: 5px;
        flex: 1;
        text-align: right;
    }

    .moreList {
        height: 300px;
        overflow-y: scroll;
        -ms-overflow-style: none;
        scrollbar-width: thin;
    }

    .moreList::-webkit-scrollbar {
        display: none;
        width: 0px;
    }

    .moreList > ul {
        display: flex;
        list-style: none;
        flex-direction: column;
        flex: 2;
    }

    .moreList > ul > li {
        width: 80%;
        height: 240%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        padding-bottom: 5px;
        background-color: white;
        border: 1px solid black;
        border-radius: 5px;
        margin-bottom: 9px;
        padding: 1% 2%;
        font-weight: bold;
    }

    .moreList > ul > li:last-child {
        padding-bottom: 3px;
    }

    .removeFile > img {
        width: 10px;
    }
</style>
